export default __webpack_public_path__ + "locales/si/InfoPanel.json?hash=ff748b9f0918a9bfdb64ce8fd3a33891";